<template>
  <div class="capability-card" :style="cardStyle">
    <div class="capability-card__image">
      <img :src="image" alt="" />
    </div>
    <h3 class="capability-card__title">{{ title }}</h3>
    <p class="capability-card__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "CapabilityCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: "#FBF8F3",
    },
    borderColor: {
      type: String,
      default: "#DDD4C4",
    },
  },
  computed: {
    cardStyle() {
      return {
        backgroundColor: this.bgColor,
        border: `1px solid ${this.borderColor}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.capability-card {
  border-radius: 16px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex: 1;

  &__image {
    width: 100%;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 14px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 14px 0;
    text-align: left;
  }

  &__subtitle {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #6a6256;
    line-height: 1.72;
    margin: 0;
    text-align: left;
  }

  @media (max-width: 767px) {
    &__title {
      font-size: 24px;
    }

    &__subtitle {
      font-size: 13px;
    }
  }
}
</style>
